import {h, Fragment} from "preact"
import { useFacet, useProductFilters } from "@nosto/preact"
import { useEffect } from "preact/hooks";
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet, toggledFacet, setToggledFacet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const { filters } = useProductFilters();

    const isEngravingFacet = facet?.field === "skus.customFields.custom-engraving_string";
    const appliedFacetFilters = filters?.filter(filter => filter.field === facet?.field);

    // console.log(facet);
    useEffect(()=>{
        if(toggledFacet === facet?.id){
            if(!active){
                toggleActive();
                // toggleActive();
            }
        } else {
            if(active){
                toggleActive();
            }
        }
    },[toggledFacet, setToggledFacet])

    return (
        // ns-mx-2
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
            <span
            // ns-p-4 ns-d-inline-block ns-font-3
                class="ns-anchor ns-relative ns-w-100 ns-border-box ns-d-inline-flex ns-justify-content-between"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
                tabIndex="0"
            >
                <span class="ns-color-black ns-d-inline-block ns-font-medium">
                    {facet.name}
                    {/* <span class="inline-block ml-1.5">
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Plus" aria-hidden="true" class="w-2.5 h-2.5">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.375 6.90625L1.625 6.90625L1.625 6.09375L11.375 6.09375L11.375 6.90625Z" fill="currentColor"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.09375 11.375L6.09375 1.625L6.90625 1.625L6.90625 11.375L6.09375 11.375Z" fill="currentColor"></path>
                        </svg>
                    </span> */}
                </span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                {/* className="ns-absolute" */}
                <Icon name="arrow" />
            </span>
            <div class="w-full max-h-[300px] transition-[max-height] duration-300 ease-in overflow-hidden group-open:ease-out group-open:max-h-0">
                <span class={`pt-[2px] paragraph-4 ${appliedFacetFilters && appliedFacetFilters?.length > 0 && !active ? "" : "hidden" }`}>
                    {appliedFacetFilters && appliedFacetFilters?.length > 0 ? appliedFacetFilters.map(filter => {
                        return (
                            <span class="pr-1.5" style="color:#404040;">
                                {isEngravingFacet && filter.value === "1" ? "Yes" : isEngravingFacet && filter.value !== "1" ? "No" : filter.value}
                            </span>
                        )
                    }) : ("")}
                </span>
            </div>
            <div class="ns-sidebar-submenu ns-d-none ns-pt-4" id={`${facet.id}-sub-menu`}>
                <ul class="ns-list-unstyled ns-p-0 ns-m-0" role="menu">
                    {facet.data?.map(value => (
                        <li
                            key={value.value}
                            // ns-justify-content-between ns-font-3
                            class="ns-d-flex ns-align-items-center"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                isEngravingFacet={isEngravingFacet}
                                onChange={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    // e.stopImmediatePropagation();
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                                // onClick={(e) => e.stopPropagation()}
                            />
                            {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-background-grey-light ns-border-radius-3">
                            </span> */}
                            
                            {`(${value.count})`}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
